import React from 'react';

const Divider = React.memo(() => {
  return <div className="w-full h-[1px] bg-[#464646] my-2 md:my-4" />;
});

export default Divider;
